export default {
  tab: 'フィードバック',
  toolbar: {
    markup: 'マークアップ',
    record: '録画',
    hint: 'クリックでコメント、ドラッグで描画',
    hintTouch: 'ドラッグして問題箇所を囲んでください',
    hintRecord: '画面を録画中',
    exit: '終了',
  },
  popup: {
    about: '概要',
    placeholder: '問題や提案を入力してください...',
    submit: '送信',
    sending: '送信中...',
    cancel: 'キャンセル',
    close: '閉じる',
    my_feedback: '自分のフィードバック',
    screenshot_label: 'スクリーンショットを添付',
    screenshot_hint: 'パスワードなどの機密項目は自動的に隠されます。',
    screenshot_short: 'スクリーンショット',
    screenshot_locked_hint: '描き込みはスクリーンショット上に焼き込まれるため、必ず添付されます。機密項目は自動的に隠されます。',
    recording_label: '記録',
    recording_locked_hint: 'ページの表示と操作の再現記録で、必ず添付されます。カメラやマイクは含まれず、機密項目は自動的に隠されます。',
    quickOptions: [
      { emoji: '🐛', label: '不具合', value: '不具合があります' },
      { emoji: '💡', label: '提案', value: '提案があります' },
      { emoji: '🤔', label: '不明点', value: 'わかりにくいです' },
    ],
  },
  success: {
    title: 'フィードバックを受け取りました。ありがとうございます。',
    title_no_ai: 'ありがとうございます！フィードバックを受け付けました。',
    close: '閉じる',
    email_saved: '解決次第メールでお知らせします。',
    email_error: 'メールアドレスを保存できませんでした。もう一度お試しください。',
    track_feedback: '対応状況を確認',
    email_cta: '解決したらメールで知らせる',
    notify: '通知',
  },
  error: {
    submit: '送信に失敗しました。もう一度お試しください。',
    finalize_title: 'まだ送信できませんでした。',
    finalize_message: 'フィードバックは保存されています。もう一度お試しください。',
  },
  pet: {
    bubble: 'お困りですか？',
  },
  frustration: {
    prompt: 'うまくいかないことがありますか？お知らせください。',
    action: '注釈',
    dismiss: '閉じる',
  },
  annotation: {
    drawing: '描画',
    element: '要素',
  },
  draw: {
    note_placeholder: '描画にメモを追加',
    undo: '元に戻す',
    redo: 'やり直す',
    cancel: 'キャンセル',
    submit: '送信',
  },
  record: {
    stop: '停止',
    timer_label: '録画中',
    max_reached: '最大記録時間に達しました',
    replay_label: 'screen-recording.json',
    play: '録画を再生',
    close: '閉じる',
    preview_unavailable: 'プレビューは利用できません',
  },
  clarify: {
    title: 'Make This Better AI',
    subtitle: 'フィードバックを整えています',
    thinking: '考え中...',
    placeholder: '詳細を追加して送信',
    send: '送信',
    submit: '送信する',
    send_feedback: 'フィードバックを送信',
    skip: 'スキップして送信',
    skip_short: 'スキップ',
    cancel: 'キャンセル — 送信しない',
    retry: '再試行',
    error: '質問を読み込めませんでした。そのままフィードバックを送信できます。',
    expired: 'このフィードバックは送信される前に有効期限が切れました。ウィジェットを閉じて、もう一度送信してください。',
  },
}
